<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
<div class="text-xl z-10 relative justify-center uppercase text-blue-900 bg-blue-100 font-medium p-4 py-16 flex">
    {{ 'NCT' | translate }}
</div>
<div class="bg-gray-300 center-height text-center">
    <p *ngIf="showSuccesMessage" class="pt-16 mx-10 pb-8 px-4 font-semibold text-lg">{{ 'ChangeEmailText-1' | translate }}</p>
    <p *ngIf="showErrorMessage" class="pt-16 mx-10 pb-8 px-4 font-semibold text-lg">{{ 'ChangeEmailText-2' | translate }}</p>
    <button
      class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
      [routerLink]="'/'">
      {{ 'GoToAuth' | translate }}
    </button>
</div>
